import { SerializeQueryArgs } from '@reduxjs/toolkit/src/query/defaultSerializeQueryArgs';

const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (key, value) => {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};

export const defaultSerializeQueryArgs: SerializeQueryArgs<any> = ({
  endpointName,
  queryArgs,
}) => `${endpointName}(${JSON.stringify(queryArgs, getCircularReplacer())})`;

export default defaultSerializeQueryArgs;
